import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
const { wp } = window;

/**
 * Rich Text component (relies on WP Core)
 */
class RichText extends PureComponent {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		this.onTextAreaChange = this.onTextAreaChange.bind( this );
	}

	/**
	 * Once component is mounted, initialize the text area
	 */
	componentDidMount() {
		const { onChange, id } = this.props;

		// We need to listen for changes from TinyMCE Visual to Text mode and vice versa.
		const editorContainer = document.querySelector(
			'.ld-answer-rt-editor'
		);
		if ( editorContainer ) {
			const observer = new MutationObserver( () => {
				// Check if the editor is switched to text mode
				editorContainer.addEventListener( 'click', function ( e ) {
					if (
						'BUTTON' === e.target.tagName &&
						e.target.classList.contains( 'switch-html' )
					) {
						// Capture input in text mode.
						editorContainer.addEventListener( 'input', function (
							e
						) {
							const textArea = editorContainer.querySelector(
								`#${ id }`
							);
							if ( e.target.id === textArea.id ) {
								// Save text mode input.
								onChange( e.target.value );
							}
						} );

						// Capture toolbar in text mode.
						const toolbar = editorContainer.querySelector(
							'.quicktags-toolbar'
						);
						// When toolbar button is clicked.
						toolbar &&
							toolbar.addEventListener( 'click', function ( e ) {
								if ( 'INPUT' === e.target.tagName ) {
									const textArea = editorContainer.querySelector(
										`#${ id }`
									);
									// Save text mode input.
									onChange( textArea.value );
								}
							} );
					}
				} );
				observer.disconnect();
			} );
			const observerConfig = {
				attributes: true,
				childList: true,
				characterData: false,
			};
			observer.observe( editorContainer, observerConfig );
		}

		setTimeout( () => {
			wp.editor.initialize &&
				wp.editor.initialize( id, {
					tinymce: {
						setup: ( editor ) => {
							editor.on( 'keyup', () => {
								onChange( editor.getContent() );
							} );

							editor.on( 'change', () => {
								onChange( editor.getContent() );
							} );

							editor.on( 'init', () => {
								editor.focus();
							} );
						},
						wpautop: true,
						plugins:
							'charmap colorpicker compat3x directionality fullscreen hr image lists media paste tabfocus textcolor wordpress wpautoresize wpdialogs wpeditimage wpemoji wpgallery wplink wptextpattern wpview',
						toolbar1:
							'formatselect bold italic | bullist numlist | blockquote | alignleft aligncenter alignright | link unlink | wp_more | spellchecker',
					},
					mediaButtons: true,
					quicktags: true,
				} );
		}, 30 );
	}

	/**
	 * Destroy the editor when component is unmounted
	 */
	componentWillUnmount() {
		wp.editor.remove && wp.editor.remove( this.props.id );
	}

	/**
	 * Fallback for when wp.editor.initialize is undefined
	 *
	 * @param {*} event The event fired when something is entered in the textarea
	 */
	onTextAreaChange( event ) {
		const { onChange } = this.props;

		if ( ! wp.editor.initialize ) {
			onChange( event.target.value );
		}
	}

	/**
	 * Render the textarea
	 */
	render() {
		const { id, value } = this.props;

		return (
			<div className="ld-answer-rt-editor">
				<textarea
					id={ id }
					defaultValue={ value }
					onChange={ this.onTextAreaChange }
				></textarea>
			</div>
		);
	}
}

/**
 * Valid props
 */
RichText.propTypes = {
	id: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
};

export default RichText;
